/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Harden_Output6Inputs */

const en_svc_mcp_server_development_harden_output6 = /** @type {(inputs: Svc_Mcp_Server_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing-ready release`)
};

const ar_svc_mcp_server_development_harden_output6 = /** @type {(inputs: Svc_Mcp_Server_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إصدار جاهز للنشر`)
};

const bn_svc_mcp_server_development_harden_output6 = /** @type {(inputs: Svc_Mcp_Server_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লিস্টিং-প্রস্তুত রিলিজ`)
};

const de_svc_mcp_server_development_harden_output6 = /** @type {(inputs: Svc_Mcp_Server_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichungsreifes Release`)
};

const es_svc_mcp_server_development_harden_output6 = /** @type {(inputs: Svc_Mcp_Server_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versión lista para publicar`)
};

const fr_svc_mcp_server_development_harden_output6 = /** @type {(inputs: Svc_Mcp_Server_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version prête à publier`)
};

const pt_svc_mcp_server_development_harden_output6 = /** @type {(inputs: Svc_Mcp_Server_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versão pronta a publicar`)
};

const zh_svc_mcp_server_development_harden_output6 = /** @type {(inputs: Svc_Mcp_Server_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可上架版本`)
};

const tr_svc_mcp_server_development_harden_output6 = /** @type {(inputs: Svc_Mcp_Server_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listelemeye hazır sürüm`)
};

const ru_svc_mcp_server_development_harden_output6 = /** @type {(inputs: Svc_Mcp_Server_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Релиз, готовый к листингу`)
};

const pl_svc_mcp_server_development_harden_output6 = /** @type {(inputs: Svc_Mcp_Server_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydanie gotowe do katalogu`)
};

/**
* | output |
* | --- |
* | "Listing-ready release" |
*
* @param {Svc_Mcp_Server_Development_Harden_Output6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_harden_output6 = /** @type {((inputs?: Svc_Mcp_Server_Development_Harden_Output6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Harden_Output6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_harden_output6(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_harden_output6(inputs)
	if (locale === "de") return de_svc_mcp_server_development_harden_output6(inputs)
	if (locale === "es") return es_svc_mcp_server_development_harden_output6(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_harden_output6(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_harden_output6(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_harden_output6(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_harden_output6(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_harden_output6(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_harden_output6(inputs)
	return en_svc_mcp_server_development_harden_output6(inputs)
});
export { svc_mcp_server_development_harden_output6 as "svc_mcp-server-development_HARDEN_output" }